import { defineStore } from "pinia";

import { UserState } from "@/types/store.interfaces";

export const userStore = {
  id: "user" as const,

  state: (): UserState =>
    ({
      id: null,
      firstname: null,
      lastname: null,
      email: null,
      phonenumber: null,
      civility: null,
      birthdate: null,
      responses: {
        clientId: null,
      },
      // Optin guide on Handbook: page /doc/les-optins-W43mNQK51u
      optins: {
        // iOptin_2 from back-end.
        emailBrand: null,
      },
      vouchers: [],
    } as UserState),

  getters: {},

  actions: {},
};

export const useUserStore = defineStore<"user", UserState>(userStore);
